import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col} from 'reactstrap';


const MissingPrivacyStatement = (props) => (
    <Row>
      <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
        <h2>
          Sorry!
        </h2>
        <p>
          Het is helaas niet mogelijk om je bij {props.clubName} online aan te melden. Neem contact op met {props.clubName} om je aanmelding door te geven.
        </p>
      </Col>
    </Row>
);

MissingPrivacyStatement.propTypes = {
  clubName: PropTypes.string.isRequired,
  unionid: PropTypes.string,
}

export default MissingPrivacyStatement;



// WEBPACK FOOTER //
// ./src/registrationform/MissingPrivacyStatement.jsx